import React, { useState } from 'react'
import Input from '../../components/common/Input';
import Modal from '../../components/common/Modal';

const Discipline = () => {
    const initialForm = {
        id: null,
        date: "",
        incident: "",
        suggestion: "",
        damage: false,
        damageAmount: "",
        action: ""
    };


    const [showModal, setShowModal] = useState(false);

    const [formData, setFormData] = useState(initialForm);


    const [incidents, setIncidents] = useState([
        {
            id: 1,
            date: "2018-01-05",
            incident: "Fight",
            suggestion: "Should pay Fine",
            damage: true,
            damageAmount: "100",
            action: "Fine"
        },
        {
            id: 2,
            date: "2018-01-05",
            incident: "Damage",
            suggestion: "Damage",
            damage: true,
            damageAmount: "150",
            action: "Damage"
        },
        {
            id: 3,
            date: "2018-03-18",
            incident: "Fight",
            suggestion: "Behave properly",
            damage: true,
            damageAmount: "500",
            action: "Suspend for two days"
        }
    ]);



    // Input Change

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target;

        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value
        });

    };



    // Edit

    const handleEdit = (item) => {

        setFormData(item);
        setShowModal(true);

    };



    // Save

    const handleSave = () => {


        if (formData.id) {

            setIncidents(
                incidents.map(item =>
                    item.id === formData.id
                        ? formData
                        : item
                )
            );


        }
        else {


            setIncidents([
                ...incidents,
                {
                    ...formData,
                    id: Date.now()
                }
            ]);


        }


        setShowModal(false);
        setFormData(initialForm);


    };



    // Delete

    const handleDelete = (id) => {

        setIncidents(
            incidents.filter(item => item.id !== id)
        );

    };


    return (
        <>
            {/* PAGE HEADER */}
            <div className="page-header">

                <div><h2>Discipline</h2></div>
                <button
                    className="btn btn-primary page-btn"
                    onClick={() => {
                        setFormData(initialForm);
                        setShowModal(true);
                    }}
                >
                    <i className="lni lni-plus fw-bold fs-4 lh-0"></i>
                    Add Discipline
                </button>
            </div>

            <div className="card shadow-sm mt-3">
                <div className="card-header d-inline">
                    <div className="">
                        <div className='row'>
                            <div className='col-md-3 col-sm-6'>
                                <Input
                                    label="Curriculam"
                                    name="Curriculam"
                                    // value={form.Curriculam}
                                    // onChange={handleChange}
                                    options={[
                                        { value: 'ssc', label: 'SSC' },
                                        { value: 'cbsc', label: 'CBSC' },
                                    ]}
                                />
                            </div>
                            <div className='col-md-3 col-sm-6'>
                                <Input
                                    label="Class"
                                    name="class"
                                    // value={form.Curriculam}
                                    // onChange={handleChange}
                                    options={[
                                        { value: '1', label: '1' },
                                        { value: '2', label: '2' },
                                    ]}

                                />
                            </div>
                            <div className='col-md-3 col-sm-6'>
                                <Input
                                    label="Section"
                                    name="section"
                                    // value={form.Curriculam}
                                    // onChange={handleChange}
                                    options={[
                                        { value: 'a', label: 'A' },
                                        { value: 'b', label: 'B' },
                                    ]}

                                />
                            </div>
                            <div className='col-md-3 col-sm-6'>
                                <Input
                                    label="Date"
                                    name="date"
                                    type="date"
                                // value={form.dob}
                                // onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-body">
                    <table className="table table-bordered table-hover">
                        <thead className="">
                            <tr>
                                <th>Date</th>
                                <th>Incident</th>
                                <th>Any Action</th>
                                <th>Suggestion</th>
                                <th>Damage Amount</th>
                                <th width="100">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                incidents.map(item => (
                                    <tr key={item.id}>
                                        <td>
                                            {item.date}
                                        </td>
                                        <td>
                                            {item.incident}
                                        </td>
                                        <td>
                                            {item.action}
                                        </td>
                                        <td>
                                            {item.suggestion}
                                        </td>
                                        <td>
                                            {item.damageAmount}
                                        </td>
                                        <td className='d-flex'>
                                            <button
                                                className="btn btn-sm btn-outline-primary me-2"
                                                onClick={() => handleEdit(item)}
                                            >
                                                <i className="bi bi-pencil"></i>
                                            </button>
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => handleDelete(item.id)}
                                            >
                                                <i className="bi bi-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
                {/* Custom Modal */}
                {
                    showModal &&

                    <Modal
                        show={showModal}
                        onClose={() => setShowModal(false)}
                        title="Add Incident Details"
                        size="lg"
                    >
                        <div className="row g-3">
                            <div className="col-md-4">
                                <label className="form-label">
                                    Date
                                </label>

                                <input
                                    type="date"
                                    className="form-control"
                                    name="date"
                                    value={formData.date}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-8">
                                <label className="form-label">
                                    Incident
                                </label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    name="incident"
                                    value={formData.incident}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-12">
                                <label className="form-label">
                                    Suggestion
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="suggestion"
                                    value={formData.suggestion}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-12">
                                <label className="form-label">
                                    Any Action
                                </label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    name="action"
                                    value={formData.action}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-6">
                                <div className="form-check mt-4">
                                    <input
                                    id="anyDamage"
                                        className="form-check-input"
                                        type="checkbox"
                                        name="damage"
                                        checked={formData.damage}
                                        onChange={(e) => {
                                            handleChange(e);
                                            if (e.target.checked) {
                                                setFormData((prev) => ({
                                                    ...prev, damageAmount: ""
                                                }))
                                            }
                                        }}
                                    />
                                    <label className="form-check-label" htmlFor="anyDamage" > Any Damage </label>
                                </div>
                            </div>

                            {
                                formData.damage && (
                                    <div className="col-md-6">
                                        <label className="form-label"> Damage Amount </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="damageAmount"
                                            value={formData.damageAmount}
                                            onChange={handleChange}
                                        />
                                    </div>
                                )
                            }
                        </div>

                        <div className="text-end mt-4">
                            <button
                                className="btn btn-secondary me-2"
                                onClick={() => setFormData(initialForm)}
                            >
                                Clear
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleSave}
                            >  Save
                            </button>
                        </div>
                    </Modal>
                }

            </div>
        </>
    )
}

export default Discipline